import { Amplify } from 'aws-amplify';
import getConfig from 'next/config';
import { logManager } from '@lib/log-manager';
import {
  TestMakerAppRouter,
  ResponderAppRouter,
  IdentityAppRouter,
  routeManager,
} from '@lib/route-manager';

export type AmplifyAppSyncConfig = {
  appSyncUrl: string;
  appSyncApiKey: string;
  region: string;
};

export function configureAmplify(config: AmplifyAppSyncConfig) {
  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: config.appSyncUrl,
        region: config.region,
        defaultAuthMode: 'apiKey' as const,
        apiKey: config.appSyncApiKey,
      },
    },
  });
}

export const bootstrap = () => {
  const environment = process.env.ENVIRONMENT;
  const { publicRuntimeConfig } = getConfig();

  if (publicRuntimeConfig?.appSync?.url && publicRuntimeConfig?.appSync?.apiKey) {
    configureAmplify({
      appSyncUrl: publicRuntimeConfig.appSync.url,
      appSyncApiKey: publicRuntimeConfig.appSync.apiKey,
      region: (publicRuntimeConfig.appSync as { region?: string }).region || 'us-east-1',
    });
  }

  // Log Manager
  logManager.init({
    appName: 'test-maker',
    environment,
  });

  // App Routers
  const branchName = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF;

  routeManager.registerStandardAppRouters({
    testMaker: TestMakerAppRouter.register({
      branchName,
      environment,
      baseUrl: process.env.APP_BASE_URL,
    }),
    responder: ResponderAppRouter.register({
      branchName,
      environment,
      baseUrl: process.env.RESPONDER_APP_URL_PATH,
    }),
    identity: IdentityAppRouter.register({
      branchName,
      environment,
      baseUrl: process.env.AUTHENTICATION_APP_URL_PATH,
    }),
  });
};
